export class RequestIdentificationModel {
    public Address: string;
    public AgencyNumber: string;
    public AreaCode: number;
    public ComercialName: string;
    public CreatedBy: string;
    public CreatedDate: Date;
    public Id: number;
    public BusinessName: string;
    public IdRequest: number;
    public ModifiedBy: string;
    public ModifiedDate: Date;
    public NameAgency: string;
    public IdGlobalName: string;
    public Phone: string;
    public DocumentTypeName: string;
    public DocumentTypeNameOld: string;
    public DocumentTypeOld: string;
    public DocumentType: string;
    public SaleTypeName: string;
    public IdSaleType: string;
    public AgencyNumberOld : string;
    public BusinessNameOld : string;
    public CommercialNameOld : string;
    public AddressOld : string;
    public AgencyWebSite: string;
    public ChangeReason : string;
    public LegalReject : boolean;
    public RejectReason : string;
}